module.exports = __webpack_public_path__ + "img/itx-file-type-tsv.1b3674ce.svg";